// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__L+GqO","footer__wrapper":"Footer_footer__wrapper__2cCsQ","footer__list":"Footer_footer__list__erA6n","footer__list_item":"Footer_footer__list_item__haAax"};